<script>
	import Box from '$lib/components/Box.svelte'
	import ContentHead from '$lib/components/ContentHead.svelte'
	import ContentWrapper from '$lib/components/ContentWrapper.svelte'
	import FullWidth from '$lib/components/FullWidth.svelte'
	import Icon from '$lib/components/Icon.svelte'
	import QuoteImage from '$lib/components/QuoteImage.svelte'
	import Saos from '$lib/components/Saos.svelte'
	import ShiftContent from '$lib/components/ShiftContent.svelte'
	import Lists from '$lib/components/lists'
	import ContentSlider from '$lib/modules/layout/ContentSlider.svelte'
	import HeaderHero from '$lib/modules/layout/HeaderHero.svelte'
	import SectionHero from '$lib/modules/layout/SectionHero.svelte'
	import { Anchor, Button } from '$lib/ui-woltair/components'
</script>

<HeaderHero fullsized bgImage="" bgColor="bg-white" wrapClass="items-center">
	<svelte:fragment slot="superheading">Jste tu správně</svelte:fragment>
	<svelte:fragment slot="heading">Sehraný a spolehlivý tým</svelte:fragment>
	<svelte:fragment slot="subheading">
		<p class="my-12 text-sm">
			Náš zákazník, náš pán. Ve Woltair chceme napravit příšernou pověst českého topenářství:
			nesplněné sliby, nedodržené termíny, nefunkční řešení. Děláme to jinak. Zákazník je pro nás
			skutečně na prvním místě –⁠ od návrhu projektu přes dodávku a montáž až po dlouhodobou péči a
			servis.
		</p>
	</svelte:fragment>
	<svelte:fragment slot="sideImage">
		<img
			src="/images/persons/woltair-technicians.webp"
			alt="Sehraný a spolehlivý tým"
			class="max-h-4/5 max-w-4/5 inline-block w-auto max-w-[80%]"
		/>
	</svelte:fragment>
	<svelte:fragment slot="buttons">
		<Button tiny href="/kalkulacka">Získat cenu vč. montáže</Button>
	</svelte:fragment>
</HeaderHero>

<section class="py-16">
	<Anchor id="dobredopadne" />
	<FullWidth bgColor="transparent">
		<SectionHero bg="linear-gradient(180deg, #F5F5F5 0%, #FFFFFF 100%) repeat-x,#FFFFFF" opaque />
		<ContentWrapper cls="px-4 py-10">
			<Saos>
				<ContentHead textAlign="text-center">
					<svelte:fragment slot="superheading">Jsme tu pro vás</svelte:fragment>
					<svelte:fragment>Odbornost a etika na prvním místě</svelte:fragment>
				</ContentHead>
				<ShiftContent grid="sm:grid gap-12 sm:grid-cols-10 pt-10">
					<div class="sm:col-span-5 lg:col-span-4">
						<Lists.OrderedList>
							<Lists.ListItem disablebg tiny>Získáte nabídku ihned on-line</Lists.ListItem>
							<Lists.ListItem disablebg tiny
								>Mají kvalifikaci a&nbsp;potřebné technické znalosti</Lists.ListItem
							>
							<Lists.ListItem disablebg tiny>
								Absolvují pravidelná odborná školení ve Woltair i&nbsp;přímo u&nbsp;výrobců
							</Lists.ListItem>
							<Lists.ListItem disablebg tiny
								>Nestranně vám poradí a netlačí vás do podepsání smlouvy</Lists.ListItem
							>
							<Lists.ListItem disablebg tiny
								>Jsou odměňováni také podle zákaznické spokojenosti</Lists.ListItem
							>
							<Lists.ListItem disablebg tiny
								>Mluví dobře česky a dodržují obchodní etický kodex</Lists.ListItem
							>
						</Lists.OrderedList>
					</div>
					<div class="hidden sm:col-span-5 sm:block lg:col-span-6">
						<img src="/images/persons/faces_2x.webp" alt="Lidé Woltairu" />
					</div>
				</ShiftContent>
			</Saos>
		</ContentWrapper>
	</FullWidth>
</section>
<section class="py-16">
	<Saos>
		<QuoteImage>
			<svelte:fragment slot="image">
				<img
					src="/images/persons/jiri_nadvornik.webp"
					alt="Jiří Nádvorník"
					class="mx-auto w-full max-md:max-w-[150px]"
				/>
			</svelte:fragment>
			<svelte:fragment slot="text">
				Woltair expert, který přichází do styku se zákazníky, nereprezentuje jen sebe, ale i celou
				firmu. Proto klademe důraz na to, aby profesionálně vystupoval a byl na něj vždycky spoleh.
				Co zákazníkovi slíbí, musí také dodržet. A pokud dojde k nějakému problému, jde ho hned
				aktivně řešit.
			</svelte:fragment>
			<svelte:fragment slot="cite">Jiří Nádvorník</svelte:fragment>
			<svelte:fragment slot="position">
				Šéf obchodních zástupců
				<br />
				oddělení tepelných čerpadel
			</svelte:fragment>
		</QuoteImage>
	</Saos>
</section>
<hr />
<section>
	<Saos>
		<ContentHead subheadingWeight="text-xs pb-6" textAlign="text-center">
			<svelte:fragment slot="superheading">Můžete nám důvěřovat</svelte:fragment>
			<svelte:fragment>
				Spolehlivost a jistota
				<br />
				mezinárodní firmy
			</svelte:fragment>
		</ContentHead>
		<div class="grid grid-cols-12">
			<div class="col-span-2 hidden xl:block" />
			<div class="col-span-12 grid grid-cols-2 gap-6 sm:grid-cols-3 xl:col-span-9">
				<div class="">
					<Icon
						src="/images/icons/black-red/globe.svg"
						width="w-14"
						height="h-14"
						margin=""
						alt="mezinárodní působení"
					/>
					<div class="mt-4 text-lg sm:text-2.5xl">Česko, Polsko, Německo, Itálie</div>
					<div class="my-4">mezinárodní působení</div>
				</div>
				<div class="">
					<Icon
						src="/images/icons/black-red/users.svg"
						width="w-14"
						height="h-14"
						margin=""
						alt="Výkon panelů"
					/>
					<div class="mt-4 text-lg sm:text-2.5xl">
						240 interních
						<br />
						200 externích
					</div>
					<div class="my-4">pracovníků</div>
				</div>
				<div class="">
					<Icon
						src="/images/icons/black-red/money.svg"
						width="w-14"
						height="h-14"
						margin=""
						alt="Výkon panelů"
					/>
					<div class="mt-4 text-lg sm:text-2.5xl">
						400 mil. Kč
						<br />
						v roce 2022
					</div>
					<div class="my-4">získané investice</div>
				</div>
			</div>
		</div>
	</Saos>
</section>
<FullWidth
	bgCenter={false}
	bgImage="/images/persons/woltair-people_2x_crop.webp"
	classes="h-96 my-16 bg-cover bg-center bg-no-repeat"
/>
<section class="py-16">
	<Saos>
		<QuoteImage alternating>
			<svelte:fragment slot="image">
				<img
					src="/images/persons/karel-naprstek-2.webp"
					alt="Karel Náprstek"
					class="mx-auto w-full max-md:max-w-[150px]"
				/>
			</svelte:fragment>
			<svelte:fragment slot="text">
				Máme nejširší nabídku energetických zařízení na trhu a do našeho portfolia zařazujeme pouze
				kvalitní produkty, kterým skutečně věříme. Nabízíme jen taková zařízení, která bychom s
				klidným srdcem nainstalovali do svého domu nebo do domu svých přátel či rodiny.
			</svelte:fragment>
			<svelte:fragment slot="cite">Karel Náprstek</svelte:fragment>
			<svelte:fragment slot="position">
				Šéf oddělení tepelných čerpadel,
				<br />
				spoluzakladatel
			</svelte:fragment>
		</QuoteImage>
	</Saos>
</section>
<section>
	<FullWidth bgColor="bg-neutral-100">
		<ContentWrapper cls="px-4">
			<Saos>
				<ShiftContent>
					<div class="content-between items-baseline justify-between py-16 md:flex">
						<div class="md:w-1/2 lg:w-1/3">
							<ContentHead>
								<svelte:fragment slot="superheading">S Woltair to dobře dopadne</svelte:fragment>
								<svelte:fragment>Kompetentní experti, kterým můžete věřit</svelte:fragment>
							</ContentHead>
						</div>
						<div class="md:w-1/2">
							<p>
								Protože nabízíme širokou škálu energetických zařízení různých světových značek,
								dokážeme porovnat různé modely a nestranně vám poradit, které řešení bude pro váš
								domov nejlepší. Nejsme závislí na žádném výrobci, takže nemáme důvod snažit se vám
								vnutit konkrétní produkt.
							</p>
						</div>
					</div>
					<div class="grid grid-cols-3 gap-x-10 gap-y-10 sm:grid-cols-6 lg:grid-cols-9">
						<Box cls="col-span-3 p-8">
							<Icon
								src="/images/icons/black-red/wrench.svg"
								width="w-10"
								height="h-10"
								margin="mt-4"
								alt="Skuteční experti."
							/>
							<div class="bold mt-4 text-lg">Skuteční experti.</div>
							<div class="my-4">Pro spokojenost zákazníka uděláme maximum.</div>
						</Box>
						<Box cls="col-span-3 p-8">
							<Icon
								src="/images/icons/black-red/users.svg"
								width="w-14"
								height="h-14"
								margin=""
								alt="Ikona kolegové"
							/>
							<div class="bold mt-4 text-lg">Své kolegy do týmu pečlivě vybíráme.</div>
							<div class="my-4">
								Dosahují vysokých, odborných, etických i komunikačních standardů.
							</div>
						</Box>
						<Box cls="col-span-3 p-8">
							<Icon
								src="/images/icons/black-red/money.svg"
								width="w-14"
								height="h-14"
								margin=""
								alt="Výkon panelů"
							/>
							<div class="bold mt-4 text-lg">Zajištujeme i pravidelné vzdělávání zaměstnanců.</div>
							<div class="my-4">
								52 interních školení ročně a k tomu odborná produktová školení přímo od výrobců.
							</div>
						</Box>
					</div>
				</ShiftContent>
			</Saos>
			<Saos>
				<ShiftContent>
					<Box cls="my-16 py-16">
						<div class="content-center items-start md:grid md:grid-cols-10">
							<div class="col-span-3">
								<img
									src="/images/persons/daniel_helcl_body.webp"
									alt="Daniel Helcl"
									class="mx-auto max-md:max-w-[150px] xl:w-[125%] xl:max-w-[125%] xl:-translate-x-1/4"
								/>
							</div>
							<div class="items-top col-span-7 grid grid-cols-8">
								<div class="quotationmark col-span-1">
									<div class="center text-8.5xl text-neutral-300">&ldquo;</div>
								</div>
								<figure class="col-span-6 xl:col-span-5">
									<blockquote class="my-16 text-1.5xl font-normal italic leading-relaxed">
										Topenářské řemeslo se stále vyvíjí; a trh přicházejí nové modely čerpadel, která
										mohou mít specifické požadavky při instalaci a manipulaci. Proto jsme spustili
										školicí centrum, kde se topenáři, chlaďaři i elektrikáři mohou proškolit v práci
										s těmi nejmodernějšími přístroji, a zároveň naše akademie slouží jako největší
										showroom tepelných čerpadel v Čechách.
									</blockquote>
									<figcaption>
										<div class="bold text-base">Daniel Helcl</div>
										<cite class="text-xs uppercase not-italic"
											>ŠÉF ODDĚLENÍ NÁKUPU A SPOLUZAKLADATEL</cite
										>
									</figcaption>
								</figure>
								<div class="quotationmark col-span-1 flex items-end">
									<div class="center text-8.5xl text-neutral-300">&rdquo;</div>
								</div>
							</div>
						</div>
					</Box>
				</ShiftContent>
			</Saos>
		</ContentWrapper>
	</FullWidth>
</section>
<section>
	<Saos>
		<ShiftContent grid="grid-cols-10 gap-8 md:grid" cls="mt-10 mb-16">
			<div class="col-span-3">
				<ContentHead>
					<svelte:fragment slot="superheading">Individuální přístup</svelte:fragment>
					<svelte:fragment>Zákazník je pro nás na prvním místě</svelte:fragment>
				</ContentHead>
			</div>
			<div class="col-span-1 hidden xl:block" />
			<div class="col-span-7 grid gap-8 pt-10 sm:grid-cols-2 lg:gap-14 xl:col-span-6">
				<div class="flex gap-6">
					<Icon
						src="/images/icons/black-red/house.svg"
						width="w-10"
						height="h-10"
						margin="mt-4"
						alt="Telefon"
					/>
					<div>
						<div class="bold mb-0 mt-4 text-lg">Začíname detailním zaměřením přímo u vás doma.</div>
						<div class="">Jen tak vám můžeme navrhnout řešení skutečně na míru.</div>
					</div>
				</div>
				<div class="flex gap-6">
					<Icon
						src="/images/icons/black-red/calculator.svg"
						width="w-10"
						height="h-10"
						margin="mt-4"
						alt="Telefon"
					/>
					<div>
						<div class="bold mb-0 mt-4 text-lg">Jsme zcela transparentní.</div>
						<div class="">
							Orientační podrobný rozpočet celé zakázky získáte u nás do minuty díky naší online
							kalkulačce.
						</div>
					</div>
				</div>
				<div class="flex gap-6">
					<Icon
						src="/images/icons/black-red/money.svg"
						width="w-10"
						height="h-10"
						margin="mt-4"
						alt="Telefon"
					/>
					<div>
						<div class="bold mb-0 mt-4 text-lg">Dokážeme vám vyjít vstříc s platbami.</div>
						<div class="">
							Při podpisu smlouvy zaplatíte jen sníženou 50% zálohu. A také individuální splátkový
							kalendář.
						</div>
					</div>
				</div>
				<div class="flex gap-6">
					<Icon
						src="/images/icons/black-red/shield.svg"
						width="w-10"
						height="h-10"
						margin="mt-4"
						alt="Telefon"
					/>
					<div>
						<div class="bold mb-0 mt-4 text-lg">Vaše spokojenost je na prvním místě.</div>
						<div class="">
							Zpětná vazba od zákazníků je pro nás důležitá, Pomáhá nám totiž odhalovat i nedostatky
							a pracovat na zlepšování našich služeb.
						</div>
					</div>
				</div>
				<div class="flex gap-6">
					<Icon
						src="/images/icons/black-red/heart.svg"
						width="w-10"
						height="h-10"
						margin="mt-4"
						alt="Telefon"
					/>
					<div>
						<div class="bold mb-0 mt-4 text-lg">Jsme féroví.</div>
						<div class="">
							Nemáme problém vám za základě kalkulace říct, pokud se vám tepelné čerpadlo nebo
							fotovoltaika nevyplatí.
						</div>
					</div>
				</div>
			</div>
		</ShiftContent>
	</Saos>
</section>
<FullWidth bgColor="bg-neutral-100">
	<ContentWrapper cls="px-8 py-16">
		<div class="w-full grid-cols-1 gap-16 sm:grid md:grid-cols-12 xl:gap-10">
			<div class="col-span-1 md:order-3 md:col-span-5 xl:col-span-4">
				<ContentHead>
					<svelte:fragment slot="superheading">Recenze na Woltair experty</svelte:fragment>
					<svelte:fragment>Hodnocení od&nbsp;zákazníků</svelte:fragment>
				</ContentHead>
				<p>U nás se planých slibů nedočkáte. Takhle hodnotí Woltair experty přímo naši zákazníci</p>
			</div>
			<div class="order-2 col-span-1 hidden xl:block" />
			<div class="py-6 md:order-1 md:col-span-7 xl:col-span-5">
				<ContentSlider
					type="quotes"
					slides={[
						{
							cite: 'Jaroslav, Boskovice',
							quote: 'Ochotný, fundovaný v&nbsp;oboru.<br>Byl jsem spokojen…'
						},
						{
							cite: 'Kamil, Radostice',
							quote: 'Byla to velmi přínosná konzultace.<br>Děkujeme.'
						},
						{
							cite: 'Romana, Vrbice',
							quote: 'Velmi slušné jednání,<br>dobrá znalost problematiky.'
						},
						{
							cite: 'Jaromír, Lanškroun',
							quote: 'Příjemná, věcná,<br>erudovaná konzultace.'
						},
						{
							cite: 'Luboš, Rosice',
							quote: 'Odborně znalý, efektivní,<br>ochotný, rychlý.'
						}
					]}
				/>
			</div>
		</div>
	</ContentWrapper>
	<ContentWrapper>
		<hr />
	</ContentWrapper>
</FullWidth>
